import { z } from 'zod'
import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '../../common'

// ======================== Listing ========================

export const PartySearchParamsSchema = z
  .object({
    q: z.string().optional(),
    includeSupplier: z.boolean().optional(),
    includeCustomer: z.boolean().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type PartySearchParams = z.infer<typeof PartySearchParamsSchema>

export const PartySearchResultModelSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  isSupplier: z.boolean(),
  isCustomer: z.boolean(),
})

export type PartySearchResultModel = z.infer<
  typeof PartySearchResultModelSchema
>

export const PartySearchResultSchema = z
  .object({
    data: z.array(PartySearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type PartySearchResult = z.infer<typeof PartySearchResultSchema>
